class SiteSearch extends HTMLElement {
  constructor() {
    super();

    this.isOpen = false;

    console.log("SiteSearch", this);

    this.searchIcon = this.querySelector(".search-icon");
    this.searchField = this.querySelector(".search-field");

    this.inputchange = this.inputchange.bind(this);
    this.searchIconClick = this.searchIconClick.bind(this);

    this.searchField.addEventListener("keydown", this.inputchange);

    this.searchIcon.addEventListener("click", this.searchIconClick);

    this.form = this.querySelector("form");

    /// close if mouse goes out side
    document.querySelector("body").addEventListener("click", (e) => {
      if (!this.contains(e.target)) {
        this.isOpen = false;
        this.update();
      }
    });

    document
      .querySelector(".main-menu-wrapper")
      ?.addEventListener("mouseleave", (e) => {
        this.isOpen = false;
        this.update();
      });
  }

  searchIconClick() {
    this.isOpen = !this.isOpen;
    this.update();
    console.log("searchIconClick", this.isOpen);
  }

  update() {
    console.log("update", this.isOpen);
    if (this.isOpen) {
      this.classList.add("open");
      this.searchField.focus();
    } else {
      this.classList.remove("open");
    }
  }

  inputchange(e) {
    console.log("inputchange", e);

    if (e.key === "Escape") {
      this.searchField.value = "";
    }

    if (e.key === "Enter") {
      console.log("search", this.searchField.value);

      // search the site
      // https://www.google.com/search?q=site:www.ourwebsite.com+searchterm

      this.form.submit();
    }
  }
}

customElements.define("site-search", SiteSearch);
